<template>
    <div
        class="data-select"
        :class="{
            'data-select__action_rlt': $store.state.isRtl,
        }"
    >
        <div class="data-select__date">
            <label class="t-transform-cap" for="input-live">{{
                getTranslatedText("select draw date")
            }}</label>
            <div class="data-select__date_input">
                <b-form-input
                    id="input-date-ticket"
                    placeholder="DD/MM/YYYY"
                    :value="renderDate()"
                    disabled
                >
                </b-form-input>
                <div @click="open" />
                <img
                    @click="open"
                    src="@/assets/images/common/datepicker.png"
                    alt="date"
                />
            </div>
        </div>
    </div>
</template>
<script>
import languageMixin from "@/mixins/language/language-mixin";
import { isStrEmpty } from "../utils";
import moment from "moment";

export default {
    mixins: [languageMixin],
    props: {
        date: {
            type: String,
            default: "",
        },
    },

    methods: {
        renderDate() {
            // let locale = this.$store.state.isRtl ? "ar" : "en";

            // moment.locale(locale);

            let date = moment(this.date).format("DD/MM/YYYY");
            return `${isStrEmpty(date) ? "" : date}`;
        },
        open() {
            this.$emit("onShowSheet");
        },
        close() {
            this.$emit("onCloseSheet");
        },
    },
};
</script>
<style
    scoped
    lang="scss"
    src="@/assets/scss/common/date-select/date-select.scss"
/>
